export default __webpack_public_path__ + "static/media/lluismas.41639e14.jpeg";